/* NUYU homepage rebuild (7 Oct 2026): the breathing app tour, and Add to basket buttons that open
   the cart drawer the same way the product page does (cart API with sections, then renderContents). */
(function () {
  if (window.__nuyuHome) return;
  window.__nuyuHome = true;
  var rm = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- App tour ---------- */
  function initTour(tour) {
    if (tour.__nhReady) return;
    tour.__nhReady = true;
    var phone = tour.querySelector('.nh-phone'),
      ims = tour.querySelectorAll('.nh-scr img'),
      fts = tour.querySelectorAll('.nh-ft'),
      tap = tour.querySelector('.nh-tap'),
      cap = tour.querySelector('.nh-cap'),
      bl = tour.querySelector('.nh-blbl'),
      row = tour.querySelector('.nh-feats');
    var n = ims.length, cur = 0, vis = false, manualUntil = 0, phase = 0;
    if (!n) return;
    function show(i) {
      ims[cur].classList.remove('is-on');
      fts[cur].classList.remove('is-on');
      fts[cur].setAttribute('aria-selected', 'false');
      cur = i;
      var im = ims[cur];
      void im.offsetWidth;
      im.classList.add('is-on');
      var f = fts[cur];
      f.classList.add('is-on');
      f.setAttribute('aria-selected', 'true');
      var bar = f.querySelector('i');
      bar.style.animation = 'none'; void bar.offsetWidth; bar.style.animation = '';
      if (cap) cap.innerHTML = '<b>' + f.querySelector('b').textContent + '</b>' + f.querySelector('span').textContent;
      phone.classList.toggle('is-buzz', f.hasAttribute('data-buzz'));
      if (row.scrollWidth > row.clientWidth + 2) row.scrollTo({ left: f.offsetLeft - row.offsetLeft - 16, behavior: rm ? 'auto' : 'smooth' });
    }
    function tapThen(i) {
      var im = ims[cur];
      tap.style.left = (im.getAttribute('data-x') || 50) + '%';
      tap.style.top = (im.getAttribute('data-y') || 40) + '%';
      tap.classList.remove('is-go'); void tap.offsetWidth; tap.classList.add('is-go');
      setTimeout(function () { show(i); }, 380);
    }
    fts.forEach(function (f, i) {
      f.addEventListener('click', function () { manualUntil = Date.now() + 12000; tour.classList.add('is-manual'); show(i); });
    });
    show(0);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { vis = e[0].isIntersecting; tour.classList.toggle('is-paused', !vis); }, { threshold: 0.25 }).observe(tour);
    } else { vis = true; }
    if (rm) { tour.classList.add('is-manual'); if (bl) bl.style.display = 'none'; return; }
    setInterval(function () {
      if (!vis) return;
      phase ^= 1;
      if (bl) { bl.style.opacity = 0; setTimeout(function () { bl.textContent = phase ? bl.getAttribute('data-out') : bl.getAttribute('data-in'); bl.style.opacity = 1; }, 250); }
      if (Date.now() < manualUntil) return;
      tour.classList.remove('is-manual');
      tapThen((cur + 1) % n);
    }, 4000);
  }

  /* ---------- Add to basket -> cart drawer ---------- */
  function addToCart(btn) {
    var id = btn.getAttribute('data-nh-add');
    if (!id || btn.disabled) return;
    var drawer = document.querySelector('cart-drawer');
    var label = btn.textContent;
    var err = btn.parentNode.querySelector('.nh-card__err');
    if (err) err.textContent = '';
    btn.disabled = true;
    btn.textContent = btn.getAttribute('data-adding') || 'Adding…';
    var body = { items: [{ id: Number(id), quantity: 1 }] };
    if (drawer && drawer.getSectionsToRender) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
      if (drawer.setActiveElement) drawer.setActiveElement(btn);
    }
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok || res.j.status) { throw new Error(res.j.description || res.j.message || 'Could not add that to your basket.'); }
        if (drawer && drawer.renderContents) {
          drawer.classList.remove('is-empty');
          var item = res.j.items && res.j.items[0] ? res.j.items[0] : res.j;
          item.sections = res.j.sections;
          drawer.renderContents(item);
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function (e) { if (err) err.textContent = e.message; })
      .finally(function () { btn.disabled = false; btn.textContent = label; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-nh-add]');
    if (b) { e.preventDefault(); addToCart(b); }
  });

  /* ---------- Swipe hint under the Edition boxes ---------- */
  function initBoxbar(row) {
    if (row.__nhBar) return;
    var bar = row.nextElementSibling;
    if (!bar || !bar.classList.contains('nh-boxbar')) return;
    row.__nhBar = true;
    var thumb = bar.firstElementChild;
    function update() {
      var max = row.scrollWidth - row.clientWidth;
      bar.classList.toggle('is-hidden', max <= 2);
      if (max <= 2) return;
      var w = row.clientWidth / row.scrollWidth;
      thumb.style.width = (w * 100) + '%';
      thumb.style.transform = 'translateX(' + ((row.scrollLeft / max) * ((1 - w) / w) * 100) + '%)';
    }
    row.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(row);
    update();
  }

  function boot() {
    document.querySelectorAll('[data-nh-tour]').forEach(initTour);
    document.querySelectorAll('.nh-boxes').forEach(initBoxbar);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
